import React from 'react';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { RiErrorWarningLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { CiMail } from 'react-icons/ci';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSuccess: boolean;
  email: string;
}

export const RecoveryPasswordModal = ({ isOpen, onClose, isSuccess, email }: ChangePasswordModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {isSuccess ? IsSuccessModal(email, onClose) : IsErrorModal(onClose)}
    </Modal>
  );
};

const IsSuccessModal = (email: string = '', onClose: () => void) => {
  const navigate = useNavigate();

  const formatEmail = (email: string): string => {
    return email.replace(/^(.)(.*)@(.*)(.{4})/g, (_, m1, m2, m3, m4) => {
      return `${m1}${'*'.repeat(m2.length)}@${'*'.repeat(m3.length)}${m4}`;
    });
  };

  const handleClose = () => {
    onClose();
    navigate('../../login');
  };

  return (
    <ModalContent padding="xxxl">
      <ModalHeader>
        <Flex flexDirection="column" justifyContent="center" alignItems="center" marginTop="xxxl">
          <Box padding="l" width="fit-content" borderRadius="full" backgroundColor="primary.800" marginBottom="xl">
            <CiMail color="white" fontSize="2em" />
          </Box>
          <Text marginTop="xl" fontSize="2xl">Revisa tu email</Text>
        </Flex>
      </ModalHeader>
      <ModalCloseButton />

      <ModalBody>
        <Text align="center">Enviamos un link para restablecer la contraseña a {formatEmail(email)}</Text>
      </ModalBody>

      <ModalFooter marginTop="xl" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Button colorScheme="button-primary" onClick={handleClose}>
          Continuar
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};

const IsErrorModal = (onClose: () => void) => {
  return (
    <ModalContent>
      <ModalHeader>
        <Box padding="l" width="fit-content" borderRadius="full" backgroundColor="destructive.700" marginBottom="xl">
          <RiErrorWarningLine color="white" fontSize="2em" />
        </Box>
        Error
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>Tu email no fue validado, por favor verifica el valor ingresado.</Text>
      </ModalBody>

      <ModalFooter>
        <Button colorScheme="red" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
